import { render, staticRenderFns } from "./CowsDewormingSecondPage.vue?vue&type=template&id=730c7fdf&scoped=true&"
import script from "./CowsDewormingSecondPage.vue?vue&type=script&lang=js&"
export * from "./CowsDewormingSecondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c7fdf",
  null
  
)

export default component.exports